import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Balance } from '@factorialco/f0-react/icons/app'
import {
  ShiftManagementBankOfHoursDocument,
  TimePlanningBalance,
} from 'generated/resources/graphql'
import moment from 'moment'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import HoursDisplay, { formatDuration } from '../HoursDisplay'

interface Props {
  shiftsRow: ShiftsRow
}

const BankOfHours = ({ shiftsRow }: Props) => {
  const [{ view }] = useSchedule()
  const today = moment()
  const { navigation } = useNavigation()

  const formatHours = (hours: number | null | undefined) => formatDuration((hours ?? 0) * 3600000)

  const { loading, data } = useQuery(ShiftManagementBankOfHoursDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      employeeIds: [shiftsRow.id],
      startAt: view.startAt,
      endAt: view.endAt,
    },
  })

  const balances = data?.timePlanning.balancesConnection.nodes.find(
    (balance: TimePlanningBalance) => balance.employeeId === shiftsRow.id
  )

  return (
    <Box flexDirection="row" alignItems="center" gap="s4">
      <F0Icon icon={Balance} size="xs" className="text-f1-icon-secondary" />
      {!loading && balances ? (
        <HoursDisplay
          title={i18n.t('shift_management.hours_information.bank_of_hours')}
          totalDuration={formatHours(balances?.bankOfHours ?? 0)}
          linkTo={navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.fullPath({
            employeeId: shiftsRow.id,
            periodType: 'weekly',
            year: today.year(),
            month: today.month() + 1,
            day: today.date(),
          })}
          hideBody
          triggerColor="grey800"
        />
      ) : (
        <Skeleton isLoading height="s16" width="s40" />
      )}
    </Box>
  )
}

export default BankOfHours
